// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Link, X } from '@phosphor-icons/react'
import { Drawer } from 'src/design-system'
import * as React from 'react'
import { OrgPersonalSkillsTableRow } from '../table/data'
import { PeopleSection } from './people-section'

type SkillDetailPanelProps = {
  skill: OrgPersonalSkillsTableRow | null
  open: boolean
  onClose: () => void
}

export const SkillDetailPanel: React.FC<SkillDetailPanelProps> = ({
  skill,
  open,
  onClose,
}) => {
  const panelRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!open) return

    const handleClickOutside = (event: MouseEvent) => {
      if (
        panelRef.current &&
        !panelRef.current.contains(event.target as Node)
      ) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [open, onClose])

  if (!skill) return null

  return (
    <Drawer
      title={skill.name}
      open={open}
      onOpen={() => {}}
      onClose={onClose}
      direction="right"
      overlay={false}
      className="w-[480px] sm:w-[520px]"
    >
      <div ref={panelRef} className="flex flex-col h-full">
        <div className="flex items-center justify-between px-6 py-4">
          <h2 className="text-lg font-bold text-gray-900 mb-0">{skill.name}</h2>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={onClose}
              className="w-8 h-8 flex items-center justify-center hover:bg-gray-100 rounded-full transition-colors"
              title="Close"
            >
              <X className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-6">
          {skill.description && (
            <div className="mb-8">
              <p className="text-sm text-gray-800 leading-relaxed mb-0">
                {skill.description}
              </p>
            </div>
          )}

          <PeopleSection usersWithProficiency={skill.usersWithProficiency} />
        </div>
      </div>
    </Drawer>
  )
}
